import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SpeakerSocialLinks from '../components/SpeakerSocialLinks';
import { SPONSOR_FORM_URL } from '../config';
import '../styles/DavidSinclairPage.css';

function DanielAmenPage() {
  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="speaker-hero">
        <video 
          className="speaker-hero-video"
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/assets/video-hero.webm" type="video/webm" />
        </video>
        <div className="speaker-hero-overlay"></div>
        
        <div className="container">
          <div className="speaker-hero-content">
            <div className="speaker-hero-left">
              <h1 className="speaker-hero-name">
                DR. DANIEL<br />AMEN
              </h1>
              <SpeakerSocialLinks speakerId="daniel-amen" className="speaker-hero-socials" linkClassName="speaker-hero-social-icon" />
              <Link to="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse speaker-hero-btn">
                CUMPĂRĂ UN TICKET
              </Link>
            </div>
            
            <div className="speaker-hero-right">
              <img 
                src="/assets/amen-speaker-transparent.png" 
                alt="Dr. Daniel Amen" 
                className="speaker-hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Who is Dr. Daniel Amen - New Section */}
      <section className="sinclair-intro">
        <div className="container">
          <div className="sinclair-intro-grid">
            <div className="sinclair-intro-content">
              <div className="sinclair-badge">DR. DANIEL G. AMEN</div>
              <h2 className="sinclair-intro-title">Cine este Dr. Daniel G. Amen</h2>
              <p className="sinclair-intro-text">
                Dr. Daniel G. Amen este medic și psihiatru (adulți și copii) și unul dintre cei mai cunoscuți <strong>experți în sănătatea creierului</strong> din lume.
              </p>
              <p className="sinclair-intro-text">
                Este fondatorul <strong>Amen Clinics</strong> și o voce care a schimbat modul în care oamenii privesc sănătatea mintală: <strong>mai puține presupuneri, mai multă înțelegere a creierului</strong>.
              </p>
              <div className="sinclair-highlight-box">
                <p>Mesajul lui e simplu: <strong>când creierul funcționează bine, și tu funcționezi bine</strong></p>
              </div>
            </div>
            <div className="sinclair-intro-image">
              <img 
                src="/assets/amen-speaker.png" 
                alt="Dr. Daniel Amen"
                className="sinclair-portrait"
              />
              {/* Floating Stats Cards */}
              <div className="floating-stats-cards">
                <div className="floating-stat-card">
                  <div className="floating-stat-number">40+</div>
                  <div className="floating-stat-label">Cărți publicate</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">260K+</div>
                  <div className="floating-stat-label">Scanări cerebrale</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">1B+</div>
                  <div className="floating-stat-label">Vizualizări online</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What He Will Talk About */}
      <section className="benefits" id="despre-ce-va-vorbi">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Despre ce va vorbi</h2>
            <p className="section-subtitle">Teme centrale din prezentarea lui Dr. Daniel Amen</p>
          </div>

          <div className="benefits-stories-grid">
            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/cum-iti-influentiaza-ziua-creierul-ziua.png)'}}>
              <div className="story-badge">Funcție cerebrală</div>
              <div className="story-content">
                <h3 className="story-title">Cum îți influențează creierul ziua</h3>
                <p className="story-description">Legătura dintre creier și somnul, energia, anxietatea și focusul tău zilnic</p>
              </div>
            </div>

            <div className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/Identifici-cauzele-reale.webp)'}}>
              <div className="story-badge story-badge-featured">Diagnostic</div>
              <div className="story-content">
                <h3 className="story-title">Aceeași problemă, cauze diferite</h3>
                <p className="story-description">De ce aceeași problemă poate arăta la fel, dar să aibă cauze complet diferite</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/ce-iti-consuma-creierul.png)'}}>
              <div className="story-badge">Obiceiuri nocive</div>
              <div className="story-content">
                <h3 className="story-title">Ce îți consumă creierul</h3>
                <p className="story-description">Obiceiuri care îți consumă creierul fără să îți dai seama</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/pasi-pentru-un-creier-sanatos.png)'}}>
              <div className="story-badge">Acțiuni simple</div>
              <div className="story-content">
                <h3 className="story-title">Pași pentru un creier sănătos</h3>
                <p className="story-description">Pași simpli pentru un creier mai sănătos, cu efect în viața de zi cu zi</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/preventie-si-protectie.png)'}}>
              <div className="story-badge">Longevitate</div>
              <div className="story-content">
                <h3 className="story-title">Prevenție și protecție</h3>
                <p className="story-description">Cum îți protejezi memoria și claritatea mentală pe termen lung</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpără un ticket</a>
          </div>
        </div>
      </section>

      {/* How It Helps You */}
      <section className="sinclair-benefits-you">
        <div className="container">
          <div className="section-header-centered">
            <h2 className="section-title">Cu ce te ajută pe tine</h2>
            <p className="section-subtitle">Beneficii concrete din prezentarea lui Dr. Daniel Amen</p>
          </div>

          <div className="benefits-you-list">
            <div className="benefit-you-item">
              <div className="benefit-you-number">01</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Înțelegere fără vină</h3>
                <p className="benefit-you-description">Înțelegi mai bine <strong>ce ți se întâmplă</strong>, fără vină și fără confuzie</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">02</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Prioritizare inteligentă</h3>
                <p className="benefit-you-description">Știi <strong>ce merită schimbat prima dată</strong>, ca să vezi rezultate mai repede</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">03</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Reguli simple de aplicat</h3>
                <p className="benefit-you-description">Ai <strong>reguli simple</strong> pentru somn, stres, energie și focus</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">04</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Performanță sustenabilă</h3>
                <p className="benefit-you-description">Îți crești <strong>performanța zilnică</strong> fără să te simți mereu pe avarie</p>
              </div>
            </div>

            <div className="benefit-you-item featured">
              <div className="benefit-you-number">05</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Bază pentru viitor</h3>
                <p className="benefit-you-description">Construiești o <strong>bază reală</strong> pentru sănătatea creierului, <strong>acum și peste ani</strong></p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse">Rezervă-ți locul acum</a>
            <p className="cta-subtitle">Locuri limitate • Brain Event 2026</p>
          </div>
        </div>
      </section>

      {/* What He Built Section */}
      <section className="sinclair-discoveries">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce a construit</h2>
            <p className="section-subtitle">Ecosistem complet pentru sănătatea creierului</p>
          </div>

          <div className="discoveries-grid">
            <div className="discovery-card featured">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="10" y="14" width="28" height="20" stroke="currentColor" strokeWidth="2" fill="none" rx="2"/>
                  <path d="M16 14V18 M24 14V18 M32 14V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="20" cy="24" r="2" fill="currentColor"/>
                  <circle cx="28" cy="24" r="2" fill="currentColor"/>
                  <path d="M16 28 Q24 32, 32 28" stroke="currentColor" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <h3 className="discovery-title">Amen Clinics</h3>
              <p className="discovery-description">Rețea cu 11 locații în SUA • Peste 260.000 scanări cerebrale • Cea mai mare bază de date de scanări SPECT din psihiatrie</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="18" r="6" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M12 32 Q18 28, 24 32 T36 32" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <circle cx="18" cy="26" r="3" fill="currentColor" opacity="0.5"/>
                  <circle cx="30" cy="26" r="3" fill="currentColor" opacity="0.5"/>
                </svg>
              </div>
              <h3 className="discovery-title">BrainMD</h3>
              <p className="discovery-description">Companie de suplimente nutraceutice bazate pe cercetările lui • Focus pe claritate mentală, energie și wellness</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="12" y="16" width="24" height="16" stroke="currentColor" strokeWidth="2" fill="none" rx="2"/>
                  <path d="M18 16V12 M24 16V12 M30 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M16 22H32 M16 26H32" stroke="currentColor" strokeWidth="1.5" opacity="0.5"/>
                </svg>
              </div>
              <h3 className="discovery-title">Amen University</h3>
              <p className="discovery-description">Program de formare pentru profesioniști • A pregătit mii de specialiști în optimizarea creierului</p>
            </div>
          </div>

          <div className="discovery-breakthrough">
            <div className="breakthrough-year">155</div>
            <div className="breakthrough-content">
              <h3 className="breakthrough-title">Bază de date globală</h3>
              <p className="breakthrough-text">
                Amen Clinics deține <strong>cea mai mare bază de date de scanări cerebrale</strong> folosită în psihiatrie, 
                cu scanări din <strong>155 de țări</strong> — un instrument revoluționar pentru înțelegerea și tratarea problemelor de sănătate mintală.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Media Presence */}
      <section className="sinclair-media-new">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Apariții și recunoaștere</h2>
            <p className="section-subtitle">Voce de top în sănătatea creierului</p>
          </div>

          <div className="media-two-column-grid">
            {/* Card 1: Books */}
            <div className="media-two-column-card">
              <div className="media-two-column-content">
                <div className="media-badge-small">Bestseller</div>
                <h3 className="media-two-column-title">12x Bestseller New York Times</h3>
                <p className="media-two-column-description">
                  Autor a <strong>peste 40 de cărți</strong> despre creier, comportament și longevitate, 
                  inclusiv 12 bestsellere New York Times care au schimbat modul în care oamenii înțeleg sănătatea mintală.
                </p>
                <div className="media-stats">
                  <div className="media-stat-item">
                    <span className="media-stat-number">40+</span>
                    <span className="media-stat-label">Cărți publicate</span>
                  </div>
                  <div className="media-stat-item">
                    <span className="media-stat-number">12x</span>
                    <span className="media-stat-label">NY Times Bestseller</span>
                  </div>
                </div>
              </div>
              <div className="media-two-column-image">
                <img src="/assets/daniel-amen-books.png" alt="Cărți Dr. Daniel Amen" />
              </div>
            </div>

            {/* Card 2: TV Specials */}
            <div className="media-two-column-card featured">
              <div className="media-two-column-image">
                <img src="/assets/tv-daniel-amen.jpg" alt="TV Specials Dr. Amen" />
              </div>
              <div className="media-two-column-content">
                <div className="media-badge-featured">TV Național</div>
                <h3 className="media-two-column-title">18 Speciale TV despre sănătatea creierului</h3>
                <p className="media-two-column-description">
                  A produs <strong>18 speciale TV naționale</strong> despre sănătatea creierului, ajungând la milioane 
                  de oameni și transformând modul în care publicul larg înțelege legătura dintre creier și comportament.
                </p>
              </div>
            </div>

            {/* Card 3: Podcast */}
            <div className="media-two-column-card">
              <div className="media-two-column-content">
                <div className="media-badge-small">Podcast</div>
                <h3 className="media-two-column-title">Change Your Brain Every Day</h3>
                <p className="media-two-column-description">
                  Gazda podcastului <strong>Change Your Brain Every Day</strong> cu <strong>peste 16 milioane de ascultări</strong>, 
                  unde împărtășește strategii practice pentru optimizarea creierului și a sănătății mintale.
                </p>
                <div className="media-stats">
                  <div className="media-stat-item">
                    <span className="media-stat-number">16M+</span>
                    <span className="media-stat-label">Ascultări podcast</span>
                  </div>
                  <div className="media-stat-item">
                    <span className="media-stat-number">1B+</span>
                    <span className="media-stat-label">Vizualizări online</span>
                  </div>
                </div>
              </div>
              <div className="media-two-column-image">
                <img src="/assets/podcast-daniel-amen.jpg" alt="Podcast Dr. Amen" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials" id="testimoniale">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce spun participanții</h2>
            <p className="section-subtitle">Feedback autentic de la ediția anterioară</p>
          </div>

          {/* Stats First - Impact Numbers */}
          <div className="testimonial-stats-hero">
            <div className="stat-hero-item">
              <div className="stat-hero-number">1000+</div>
              <div className="stat-hero-label">Participanți</div>
              <div className="stat-hero-sublabel">ediția trecută</div>
            </div>
            <div className="stat-hero-divider"></div>
            <div className="stat-hero-item stat-hero-featured">
              <div className="stat-hero-number">10/10</div>
              <div className="stat-hero-label">Rating mediu</div>
              <div className="stat-hero-sublabel">satisfacție maximă</div>
            </div>
            <div className="stat-hero-divider"></div>
            <div className="stat-hero-item">
              <div className="stat-hero-number">95%</div>
              <div className="stat-hero-label">Recomandare</div>
              <div className="stat-hero-sublabel">ar participa din nou</div>
            </div>
          </div>

          {/* Testimonials Grid */}
          <div className="testimonials-grid-modern">
            {/* Testimonial 1 - Featured Large */}
            <div className="testimonial-card-modern featured-large">
              <div className="testimonial-quote-icon">"</div>
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Am plecat cu un plan concret pentru somn și am văzut rezultate în doar 5 zile. Claritate mentală pe care nu am mai simțit-o de ani. Protocoalele sunt simple dar puternice."</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>AM</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Ana Maria</strong>
                  <span className="author-role-modern">Antreprenor, 34 ani</span>
                  <span className="author-result">✓ Focus +40% în 7 zile</span>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="testimonial-card-modern">
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Ca psiholog, am găsit protocoale practice pe care le-am integrat imediat cu clienții mei. Schimbarea a fost vizibilă în primele 2 săptămâni."</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>RP</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Radu Popa</strong>
                  <span className="author-role-modern">Psiholog clinician</span>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="testimonial-card-modern">
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Informații dense dar accesibile. Am ieșit cu instrumente măsurabile și o comunitate de oameni pasionați de aceleași lucruri."</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>MC</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Maria Cristea</strong>
                  <span className="author-role-modern">Biohacker & Coach</span>
                </div>
              </div>
            </div>

            {/* Testimonial 4 */}
            <div className="testimonial-card-modern">
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Mi-am rezolvat problemele de somn după 10 ani de încercări. Acum dorm 7h/noapte și mă trezesc energizat. Schimbător de viață!"</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>DI</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Dan Ionescu</strong>
                  <span className="author-role-modern">Developer, 29 ani</span>
                </div>
              </div>
            </div>

            {/* Testimonial 5 - Video Style */}
            <div className="testimonial-card-modern video-style">
              <div className="video-badge">🎥 Recenzie Video</div>
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Cel mai practic eveniment la care am participat. Zero fluff, doar acțiuni concrete. Workbook-ul e aur curat!"</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>SI</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Simona Ilie</strong>
                  <span className="author-role-modern">Manager HR</span>
                </div>
              </div>
            </div>

            {/* Testimonial 6 */}
            <div className="testimonial-card-modern">
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Am venit sceptic, am plecat convins. Informațiile sunt bazate pe știință, nu pe hype. Super valoros pentru echipa mea."</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>AL</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Alex Luca</strong>
                  <span className="author-role-modern">CEO Startup</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Speakers Section - Same Style as "Ce obții la eveniment" */}
      <section className="benefits" id="speakeri">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Alți Speakeri de la Brain Event 2026</h2>
            <p className="section-subtitle">Experți de top din domeniul neuroștiinței și optimizării cognitive</p>
          </div>

          <div className="benefits-stories-grid">
            {/* David Sinclair */}
            <Link to="/david-sinclair" className="benefit-story-card" style={{backgroundImage: 'url(/david-sinclair-headshot-2024.png)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">David Sinclair</h3>
                <p className="story-description">Cercetător în Longevitate • Harvard</p>
                {/* <SpeakerSocialLinks speakerId="david-sinclair" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Diana Palotas */}
            <Link to="/diana-palotas" className="benefit-story-card" style={{backgroundImage: 'url(/assets/Diana-Palotas-card.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Diana Palotas</h3>
                <p className="story-description">CEO Neuros</p>
                {/* <SpeakerSocialLinks speakerId="diana-palotas" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Niculina Gheorghiță */}
            <Link to="/niculina-gheorghita" className="benefit-story-card" style={{backgroundImage: 'url(/assets/niculina-psiholog.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Niculina Gheorghiță</h3>
                <p className="story-description">Psiholog • Autor • Trainer</p>
              </div>
            </Link>

            {/* Matthew Walker - Featured */}
            <Link to="/matthew-walker" className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/matthew-walker-speaker.webp)'}}>
              <div className="story-badge story-badge-featured">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Matthew Walker</h3>
                <p className="story-description">Expert în Somnologie • Autor Bestseller</p>
              </div>
            </Link>

            {/* Specialist Neurofiziologie */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Specialist Neurofiziologie</h3>
                <p className="story-description">A definit standardele moderne ale neruofiziologiei</p>
              </div>
            </div>

            {/* Expert Neuromodulare */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Expert Neuromodulare</h3>
                <p className="story-description">A optimizat recuperarea sistemului nervos</p>
              </div>
            </div>

            {/* Psiholog si Formator */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Psiholog si Formator</h3>
                <p className="story-description">Trei Decenii in practica psihologica</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpara un ticket</a>
          </div>
        </div>
      </section>

      {/* Contact / Sponsor form — now on dedicated sponsorship app */}
      <section className="speaker-contact">
        <div className="container">
          <div className="speaker-contact-header">
            <h2 className="speaker-contact-title">Ai întrebări despre Dr. Daniel Amen sau Brain Event?</h2>
            <p className="speaker-contact-subtitle">
              Completează formularul de sponsorizare și echipa noastră te va contacta în cel mai scurt timp.
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <a href={SPONSOR_FORM_URL} className="btn btn-primary btn-large">Aplică pentru Sponsorizare</a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default DanielAmenPage;






